import { useTranslation } from 'react-i18next';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_MMMM_YYYY } from '@/helpers/common';
import IconInfo from './icon_info.svg';
import IconClose from './icon_close.svg';
import s from './index.module.scss';

export const Card = ({ data, setClosed }) => {
  const { t } = useTranslation('loans');
  return (
    <div className={s.card}>
      <div className={s.card_icon}>
        <img src={IconInfo} alt="info" width={24} height={24} />
      </div>
      <div className={s.card_content}>
        <div className="f-body-accent">
          {t('shift_payment_info.banner_title', {
            brands: data.brands.join(', '),
          })}
        </div>
        <div className="f-small-regular">
          {data.earnings_amount < 0.01
            ? t('shift_payment_info.banner_content_zero', {
                rescheduleAmount: prettyFloatMoney(data.reschedule_amount),
                date: prettyDate(data.deadline, DATE_FORMAT_MMMM_YYYY),
              })
            : t('shift_payment_info.banner_content', {
                rescheduleAmount: prettyFloatMoney(data.reschedule_amount),
                date: prettyDate(data.deadline, DATE_FORMAT_MMMM_YYYY),
                earningsAmount: prettyFloatMoney(data.earnings_amount),
              })}
        </div>
      </div>
      <button type="button" className={s.close} onClick={() => setClosed(true)}>
        <img src={IconClose} alt="close" width={24} height={24} />
      </button>
    </div>
  );
};
